<template>
  <view class="container">
    <!-- 加载状态 -->
    <view v-if="loading" class="loading-box">
      <text class="loading-text">正在跳转...</text>
    </view>
    
    <!-- 错误提示 -->
    <view v-else-if="error" class="error-box">
      <text class="error-text">{{ errorMsg }}</text>
      <button class="retry-btn" @click="handleJump">重新跳转</button>
    </view>
  </view>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'JumpPage',
  setup() {
    const router = useRouter()
    const loading = ref(true)
    const error = ref(false)
    const errorMsg = ref('')

    // 微信小程序配置
    const WECHAT_CONFIG = {
      appid: 'wxe908e591b3eb1688',
      path: 'pages/meiye/order/show/index'
    }

    // 构建跳转链接
    const buildJumpUrl = (orderId) => {
      const para = encodeURIComponent(`orderId=${orderId}`)
      return `weixin://dl/business/?appid=${WECHAT_CONFIG.appid}&path=${WECHAT_CONFIG.path}&query=${para}`
    }

    // 执行跳转
    const handleJump = () => {
      try {
        const orderId = router.currentRoute.value.params.id
        
        // 参数校验
        if (!orderId) {
          throw new Error('订单 ID 不能为空')
        }

        const appUrl = buildJumpUrl(orderId)
        window.location.href = appUrl
        
        // 延迟关闭加载状态（给跳转留出时间）
        setTimeout(() => {
          loading.value = false
        }, 2000)
      } catch (err) {
        loading.value = false
        error.value = true
        errorMsg.value = err.message || '跳转失败，请重试'
        console.error('跳转错误:', err)
      }
    }

    onMounted(() => {
      handleJump()
    })

    return {
      loading,
      error,
      errorMsg,
      handleJump
    }
  }
}
</script>

<style scoped>
.container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-text {
  font-size: 16px;
  color: #666;
  margin-top: 16px;
}

.error-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
}

.error-text {
  font-size: 16px;
  color: #ff4d4f;
  margin-bottom: 20px;
}

.retry-btn {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 10px 30px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}

.retry-btn:active {
  background-color: #096dd9;
}
</style>